var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVectorUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41 8L6 3.43414L10.59 8L12 6.58747L6 0.619028L0 6.58747L1.41 8Z",
    fill: "#171717"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUp);
export default __webpack_public_path__ + "static/media/VectorUp.ec0fa54d9b4d50c3cac4801fb0659d9e.svg";
export { ForwardRef as ReactComponent };